import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { FeatureExposed } from "@/utils/feature-exposed";

import { HeroCards, LogoBanner } from "./components";
import { LoggedOutHeader } from "./components/logged-out-header";
import { LoggedOutJiraProductTourAccountCreation } from "./components/logged-out-jira-product-tour-embedded-signup-form";

export const LoggedOutHeroSection = () => {
    const intl = useIntl();

    const headerContent = {
        mainHeadingFirstPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.first-header-text",
            defaultMessage: "Great outcomes"
        }),
        mainHeadingSecondPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.second-header-text",
            defaultMessage: "start with Jira"
        }),
        subHeading: intl.formatMessage({
            id: "jira-product-tour.hero-header.sub-header-text",
            defaultMessage:
                "The only project management tool you need to plan and track work across every team."
        }),
        buttonText: intl.formatMessage({
            id: "jira-product-tour.hero-header.button-text",
            defaultMessage: "Get Jira free"
        })
    };

    return (
        <FeatureExposed
            experimentKey="jfind-jpto-organic-optimize-embedded-signup"
            group="Test"
        >
            <div css={heroStyles}>
                <div css={containerStyles}>
                    {/* @ts-ignore */}
                    <LoggedOutHeader {...headerContent} />
                    <div css={formStyles}>
                        <LoggedOutJiraProductTourAccountCreation />
                    </div>
                </div>
                <HeroCards />
            </div>
            <LogoBanner />
        </FeatureExposed>
    );
};

LoggedOutHeroSection.displayName = "LoggedOutHeroSection";

const heroStyles = css({
    // eslint-disable-next-line local/ensure-wac-token-usage
    background: "#F4F5F7",
    width: "100%"
});

const containerStyles = css({
    display: "flex",
    maxWidth: "1024px",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "auto",
    gap: "48px",
    [media.below.md]: {
        padding: "0 24px"
    },
    [media.below.sm]: {
        flexDirection: "column"
    },
    [media.below.xs]: {
        gap: "24px"
    }
});

const formStyles = css({
    maxWidth: "450px",
    width: "100%",
    [media.above.sm]: {
        paddingBlockStart: "48px"
    }
});
